<template>
  <div class="relative flex justify-center items-center w-full h-full">
    <img class="disappear z-10" src="../../assets/ThingsToNote/feetCombination.svg" />
    <div class="flex justify-center items-center absolute w-full h-full">
      <div class="movingParts z-20">
        <img src="../../assets/ThingsToNote/img_foot_L.svg" class="lFoot absolute" />
        <img src="../../assets/ThingsToNote/img_foot_R.svg" class="rFoot absolute" />
        <img src="../../assets/ThingsToNote/orangeLine.svg" class="orangeLine absolute" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Feet',
};
</script>

<style lang="scss" scoped>
.lFoot {
  margin-left: -24vw;
  margin-top: -22vw;
  animation: lFoot 3s 0s ease-in-out both;
}
.rFoot {
  margin-left: 12vw;
  margin-top: -22vw;
  animation: rFoot 3s 0s ease-in-out both;
}
.movingParts {
  margin-bottom: 15%;
  margin-left: 5%;
}
.disappear {
  animation: feetDisappear 2s 1s ease-in-out both;
}
@keyframes feetDisappear {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes orangeAppear {
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0.3;
  }
  80% {
    opacity: 1;
  }
}
@keyframes lFoot {
  40% {
    transform: translate(0px, 0px);
  }
  85% {
    transform: translate(50px, 110px);
  }
  100% {
    transform: translate(50px, 110px);
  }
}
@keyframes rFoot {
  0% {
    transform: translate(0px, 0px);
  }
  40% {
    transform: translate(0px, 0px);
  }
  85% {
    transform: translate(-55px, 110px);
  }
  100% {
    transform: translate(-55px, 110px);
  }
}
.orangeLine {
  margin-left: -21.8vw;
  margin-top: 17.3vw;
  animation: orangeAppear 3s 0s ease-in-out both;
}
@media screen and (min-width: 1024px) {
  .bodyLine {
    margin-top: -17vw;
  }
  .blackShirt {
    margin-top: 3.8rem;
  }
  .hairBun {
    margin-top: -13vw;
  }
  .hairLine1 {
    height: 6.5vh;
    margin-left: 10.5vw;
    margin-top: -11vw;
  }
  .hairLine2 {
    height: 6.5vh;
    margin-left: 10.5vw;
    margin-top: 2.5vw;
  }
  .necklace {
    margin-left: -4.7vw;
    margin-top: -17vw;
  }
  .watch {
    margin-left: 12vw;
  }
  .lFoot {
    margin-left: -17.9vw;
    margin-top: -16.1vw;
  }
  .rFoot {
    margin-left: 9.1vw;
    margin-top: -16.1vw;
  }
  .orangeLine {
    margin-left: -16.3vw;
    margin-top: 13.1vw;
  }
}
</style>
